import {Component, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {PlanLinkageEntry} from "../../../../../api/models/plan-linkage-entry";
import {QualityGateService} from "../../../../../api/services/quality-gate.service";
import {StatusDetail} from "../../../../../api/models/status-detail";
import {MessageService} from "primeng/api";
import {ViewTradingPlansComponent} from "../view-trading-plans/view-trading-plans.component";

@Component({
  selector: 'app-view-plan-linkage',
  templateUrl: './view-plan-linkage.component.html',
  styleUrl: './view-plan-linkage.component.css',
  standalone: false
})
export class ViewPlanLinkageComponent implements OnInit {

  planEntry: PlanLinkageEntry = {};
  listOfEntries: PlanLinkageEntry[] = [];

  first = 0;
  rows = 10;
  readonly paginator = {pageSize: 1, pageNumber: 1, totalCount: 1};
  isLoading = false;
  isEditMode = true;


  constructor(private config: DynamicDialogConfig,
              public ref: DynamicDialogRef,
              private dialogService: DialogService,
              private _messageService: MessageService,
              private _qualityGateService: QualityGateService) {

    if (config.data) {
      this.planEntry = config.data as PlanLinkageEntry;
      this.listOfEntries = [this.planEntry];
      this.isEditMode = config.data.status == null
    }

  }

  ngOnInit(): void {
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  onExcludeClick(share: PlanLinkageEntry, action: string) {
    if (action == 'MODIFY') {
      const ref = this.dialogService.open(ViewTradingPlansComponent, {
        dismissableMask: false,
        closable: true,
        modal: true,
        showHeader: true,
        style: {width: "60vw"},
        contentStyle: {overflow: "auto"},
        header: "Select Plan to Link",
        data: share,
      });
      ref.onClose.subscribe((refresh) => {
        if (refresh) {
          this.planEntry.adoptionTradingPlanId = refresh.tradingPlanId;
          this.planEntry.adoptionUrl = refresh.url;
        }
      });
      return;
    }

    if (action == 'CONNECT' && !share.adoptionTradingPlanId) {
      this._messageService.add({
        severity: "error",
        summary: "PlanId is not provided"
      });
      return;
    }

    let adoptedTradingPlanId = share.adoptionTradingPlanId;
    if (action == 'EXCLUDED') {
      adoptedTradingPlanId = undefined;
    }

    this._qualityGateService.submit({
      qualityGateType: "PlanLinkage",
      planLinkageSubmission: {entryId: share.entryId, status: action, adoptedTradingPlanId: adoptedTradingPlanId}
    }).subscribe({
      next: (value: StatusDetail) => {
        if (value.result) {
          this._messageService.add({
            severity: "success",
            summary: "Submission Successful",
            detail: "The record has been " + (action === 'EXCLUDED' ? "excluded" : "connected") + " successfully.",
          });
        }
      },
      complete: () => {
        setTimeout(() => {
          this.ref.close({refresh: true});
        }, 2000);
      }
    });

  }
}
